<template>
  <BModal :model-value="modal" scrollable centered title="Room" hide-footer @update:modelValue="updateModal" > 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">Room</h5>
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group">
        <BFormSelect v-model="selectType" :options="types" class="form-select">
          <template #first>
            <BFormSelectOption :value="null" disabled>Select type room</BFormSelectOption>
          </template>
        </BFormSelect>
        
      </div>
      <div class="form-group">
        <BFormInput type="text" placeholder="Room Number">
        </BFormInput>
      </div>
      <div class="form-group">
        <BFormInput type="color">
        </BFormInput>
      </div>
      <BRow>
        <BCol lg="6">
          <div class="form-group">
            <label for="">Normal Price/Low Season</label>
            <BFormInput type="number" placeholder="Normal Price/Low Season">
            </BFormInput>
          </div>
        </BCol>
        <BCol lg="6">
          <div class="form-group">
            <label for="">High Season</label>
            <BFormInput type="number" placeholder="High Season">
            </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <BFormSelect v-model="selectStatus" :options="status_rooms" class="form-select">
          <template #first>
            <BFormSelectOption :value="null" disabled>Select status room</BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
    </BForm>
    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton variant="primary" @click="submitReservation" class="mr-2">Save</BButton>
            <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
        </div>
    </template>
  </BModal>
</template>

<script>
import { ref } from "vue";

import { 
    BButton, 
    BRow,
    BCol,
    BModal,
    // BBadge, 
    BForm, 
    BFormSelect,
    BFormSelectOption,
    BFormInput,
  } from "bootstrap-vue-next";
  
  export default {
    components: {
      BRow,
      BCol,
      BForm,
      BFormSelect,
      BFormSelectOption,
      BFormInput,
      BButton,
      BModal,
      // BBadge,
        
    },
    props: {
        modal: Boolean,
    },
    emits: ["update:modal"],
    setup(props, {emit}){
        console.log(props)
        const selectStatus = ref(null)
        const status_rooms = ref([
          {text: 'Available', value: 'available'},
          {text: 'Reserved', value: 'reserved'},
          {text: 'Check In', value: 'check_in'},
          {text: 'Check Out', value: 'check_out'},
          {text: 'Dirty', value: 'dirty'},
          {text: 'Under Maintenance', value: 'under_maintenance'},
          {text: 'In Cleaning', value: 'in_cleaning'},
        ])
        const selectType = ref(null)
        const types = ref([
          {text: 'Deluxe', value: 'deluxe'},
          {text: 'Super Deluxe', value: 'super_deluxe'},
          {text: 'Family', value: 'family'},
          {text: 'Studio', value: 'studio'},
          {text: 'Honeymoon', value: 'honeymoon'},
        ])

        const label_rooms = ref([
          {
            label: 'Merah', color: '🟥'
          },
          {
            label: 'Hijau', color: '🟩'
          },
          {
            label: 'Biru', color: '🟦'
          },
          {
            label: 'Putih', color: '⬜'
          },
          {
            label: 'Orange', color: '🟧'
          },
        ])
        const updateModal = (value) => {
                emit("update:modal", value); // Sync modal state with parent
            };
        return{
            updateModal,
            status_rooms,
            types,
            label_rooms,
            selectStatus,
            selectType,
        }
    }
}
</script>

<style>

</style>